// The backend currently exposes traders and clients as `user`, so trader-only
// frontend areas must use this explicit allowlist. Server endpoints still own
// the authoritative authorization decision.
export const TRADER_LOGINS: string[] = ['Ivan_E_trader', 'night_1_user', 'night_2_user'];

export const canSeeTraderArea = (user?: { role: string; login: string } | null): boolean =>
  Boolean(user && (user.role === 'admin' || TRADER_LOGINS.includes(user.login)));
